export default {
  common: {
    active: 'Идэвхтэй',
    add: 'Нэмэх',
    advancedFunctions: 'Нарийвчилсан функцууд',
    and: 'ба',
    appName: 'Арена',
    appNameFull: '$t(common.openForis) Арена',
    apply: 'Хэрэгжүүлэх',
    aggregateFunction: 'Нэгдсэн функц',
    aggregateFunction_other: 'Нэгдсэн функцууд',
    avg: 'Дундаж',
    ascending: 'Өсөх',
    areaBased: 'талбай дээр суурилсан',
    back: 'Буцах',
    baseUnit: 'Суурь нэгж',
    cancel: 'Цуцлах',
    cancelConfirm: `**Хадгалгдаагүй өөрчлөлтүүд байна**.

Хадгалахгүй орхих уу?`,
    cantUndoWarning: 'Энэ үйлдлийг буцаах боломжгүй',
    cantBeDeletedUsedItem: 'Энэ {{item}} нь зарим зангилааны тодорхойлолтуудад ашиглагдсан тул устгах боломжгүй',
    chain: 'Гинж',
    chain_plural: 'Гинжүүд',
    childrenEmpty: 'Наад зах нь нэг хүүхэд элементийг тодорхойлно уу',
    clear: 'Арилгах',
    clone: 'Хувилах',
    close: 'Хаах',
    cloneFrom: 'Үүнээс хувилах',
    cnt: 'Тоо',
    code: 'Код',
    collapse: 'Хумих',
    confirm: 'Батлах',
    convert: 'Хөрвүүлэх',
    copy: 'Хуулах',
    createdWith: 'Үүсгэсэн',
    createdWithApp: `$t(common.createdWith) {{app}}`,
    cycle: 'Мөчлөг',
    cycle_plural: 'Мөчлөгүүд',
    dateCreated: 'Үүсгэсэн огноо',
    dateLastModified: 'Сүүлд өөрчилсөн огноо',
    delete: 'Устгах',
    deleted: 'Устгагдсан!',
    descending: 'Буурах',
    description: 'Тайлбар',
    description_plural: 'Тайлбарууд',
    designerNotes: 'Дизайнерын тэмдэглэл',
    designerNotesInfo: `Дизайнерын тэмдэглэл зөвхөн судалгааны маягт дизайнерт харагдах бөгөөд өгөгдөл оруулах маягтанд харагдахгүй.`,
    details: 'Дэлгэрэнгүй',
    dimension: 'Хэмжээс',
    dimension_other: 'Хэмжээсүүд',
    done: 'Болсон',
    download: 'Татах',
    draft: 'Ноорог',
    edit: 'Засах',
    email: 'Имэйл',
    email_other: 'Имэйлүүд',
    emailSentConfirmation: `{{email}} руу имэйл илгээсэн.

    Хүлээн авагчид Спам/Хог шуудангийн хавтсыг шалгахыг анхааруулна уу.`,
    emailSentToSelfConfirmation: `Та {{email}} руу имэйл хүлээн авсан байх ёстой.

Спам/Хог шуудангийн хавтсыг шалгана уу.`,
    empty: 'Хоосон',
    entity: 'Объект',
    error: 'Алдаа',
    error_plural: 'Алдаанууд',
    errorFound: '1 алдаа олдов',
    errorFound_other: '{{count}} алдаа олдов',
    errorMessage: 'Алдааны мессеж',
    errorMessage_plural: 'Алдааны мессежүүд',
    expand: 'Дэлгэх',
    expandCollapse: '$t(common.expand) / $t(common.collapse)',
    export: 'Экспортлох',
    exportAll: 'Бүгдийг экспортлох',
    exportToCSV: 'CSV руу экспортлох',
    exportToExcel: 'Excel руу экспортлох',
    exportToExcelTooManyItems: 'Excel руу экспортлоход хэт олон элемент байна; CSV экспортлолтыг ашиглана уу.',
    expression: 'Илэрхийлэл',
    false: 'Худал',
    file: 'Файл',
    file_plural: 'Файлууд',
    formContainsErrors: 'Маягт алдаатай байна',
    formContainsErrorsCannotContinue: 'Маягт алдаатай байна. Үргэлжлүүлэхийн өмнө засарна уу.',
    formContainsErrorsCannotSave: 'Маягт алдаатай байна. Хадгалахын өмнө засарна уу.',
    from: 'Эхлэл',
    function: 'Функц',
    goToHomePage: 'Нүүр хуудас руу очих',
    goToSurveys: 'Судалгааны жагсаалт руу очих',
    group: 'Бүлэг',
    help: 'Тусламж',
    hide: 'Нуух',
    id: 'id',
    import: 'Импортлох',
    importFromExcelOrCSVFile: 'Excel (.xlsx) эсвэл CSV файлаас импортлох',
    info: 'Мэдээлэл',
    invalid: 'ХҮЧИНГҮЙ',
    item: 'Элемент',
    item_plural: 'Элементүүд',
    itemAlreadyAdded: 'Элемент нэмэгдсэн байна',
    label: 'Шошго',
    label_plural: 'Шошгууд',
    language: 'Хэл',
    language_plural: 'Хэлнүүд',
    leavePageConfirmMessage: `Маягтанд хадгалгдаагүй өөрчлөлтүүд байна.

Батлахдаа, бүх өөрчлөлтүүд алдагдана.
Үргэлжлүүлэх үү?`,
    local: 'Орон нутгийн',
    loading: 'Ачаалж байна...',
    lock: 'Түгжих',
    unlock: 'Түгжээг тайлах',
    max: 'Хамгийн их',
    med: 'Дундаж',
    manage: 'Удирдах',
    message_plural: 'Мессежүүд',
    measure: 'Хэмжилт',
    measure_other: 'Хэмжилтүүд',
    measurePrevSteps: 'Өмнөх алхмуудыг хэмжих',
    measurePrevSteps_plural: 'Өмнөх алхмуудыг хэмжих',
    min: 'Хамгийн бага',
    name: 'Нэр',
    new: 'Шинэ',
    next: 'Дараах',
    no: 'Үгүй',
    noItems: `$t(common.no) $t(common.item_plural)`,
    notSpecified: '---Заагаагүй---',
    orderBy: 'Эрэмбэлэх',
    of: '-ийн',
    ok: 'Тийм',
    openForis: 'Нээлттэй Форис',
    openForisShort: 'OF',
    openInNewWindow: 'Шинэ цонхонд нээх',
    options: 'Сонголтууд',
    owner: 'Эзэмшигч',
    path: 'Зам',
    pause: 'Түр зогсоох',
    preview: 'Урьдчилан харах горим',
    previous: 'Өмнөх',
    publish: 'Нийтлэх',
    publishConfirm: `#### Та {{survey}} судалгааг нийтлэх гэж байна ####

###### Нийтлэх үйл явц дараах мэдээллийг *буцаах боломжгүйгээр устгах* болно ######
- Устгагдсан хэлнүүдтэй холбоотой шошгууд.
- Устгагдсан мөчлөгүүдтэй холбоотой бичлэгүүд.
- Устгагдсан маягтын талбаруудтай холбоотой өгөгдөл.

###### Нийтэлсний дараа: ######
- Маягтын талбаруудыг нэгээс олон болгох боломжгүй.
- Ангиллын элементүүдийн кодыг өөрчлөх боломжгүй.
- Ангиллын элементүүдийг устгах боломжгүй.
- Таксономын кодыг өөрчлөх боломжгүй.
- Таксонуудыг устгах боломжгүй.

**Үргэлжлүүлэхдээ итгэлтэй байна уу?**`,
    raiseTicketInSupportForum: `Асуудал гарвал манай <b>Дэмжлэгийн Форум</b>: $t(links.supportForum) руу 'arena' шошготой тасалбар үүсгэнэ үү.`,
    record: 'Бичлэг',
    record_other: 'Бичлэгүүд',
    remote: 'Алсын',
    required: 'Шаардлагатай',
    requiredField: 'шаардлагатай талбар',
    reset: 'Дахин тохируулах',
    refresh: 'Шинэчлэх',
    pressRefreshToReloadPage: 'Хуудсыг дахин ачаалахын тулд Шинэчлэх товчийг дарна уу.',
    resume: 'Үргэлжлүүлэх',
    retry: 'Дахин оролдох',
    role: 'Үүрэг',
    save: 'Хадгалах',
    saveAndBack: 'Хадгалах ба буцах',
    saved: 'Хадгалсан!',
    samplingPolygon: 'Түүвэрлэх олон өнцөгт',
    show: 'Харуулах',
    select: 'Сонгох',
    selectOne: 'Нэгийг сонгоно уу...',
    selectAll: 'Бүгдийг сонгох',
    selected: 'Сонгогдсон',
    showLabels: 'Шошго харуулах',
    showLabelsAndNames: 'Шошго ба нэр харуулах',
    showNames: 'Нэр харуулах',
    sort: 'Эрэмбэлэх',
    sortAsc: 'Өсөх эрэмбэ',
    sortDesc: 'Буурах эрэмбэ',
    sortNone: 'Эрэмбэ арилгах',
    srs: 'SRS',
    status: 'Төлөв',
    sum: 'Нийлбэр',
    test: 'Турших',
    to: 'Хүртэл',
    totalItems: 'Нийт элемент',
    true: 'Үнэн',
    trySplittingFileIntoSmallerChunks: 'Файлыг жижиг хэсгүүдэд хуваахыг оролдоно уу.',
    type: 'Төрөл',
    undefinedName: 'Тодорхойгүй нэр',
    unique: 'Өвөрмөц',
    upload: 'Байршуулах',
    uploadErrorConfirm: {
      message: `Файл хуулах явцад алдаа гарлаа: {{error}}.\n
Дахин оролдох уу?`,
    },
    uploadFileChangedError: 'Сонгосон файл сонгосноос хойш өөрчлөгдсөн бололтой байна. Түүнийг дахин сонгоно уу.',
    uploadingFile: 'Файл байршуулж байна ({{progressPercent}}%)',
    value: 'Утга',
    view: 'Харах',
    warning: 'Анхааруулга',
    warning_plural: 'Анхааруулгууд',
    yes: 'Тийм',
    date: {
      aMomentAgo: 'Саяхан',
      hour: 'цаг',
      hour_other: 'цаг',
      day: 'өдөр',
      day_other: 'өдөр',
      minute: 'минут',
      minute_other: 'минут',
      week: 'долоо хоног',
      week_other: 'долоо хоног',
      timeDiff: `{{count}} $t(common.date.{{unit}}, { 'count': {{count}} }) өмнө`,
    },
    paginator: {
      firstPage: 'Эхний хуудас',
      itemsPerPage: 'Нэг хуудсанд ногдох элемент',
      lastPage: 'Сүүлийн хуудас',
      nextPage: 'Дараагийн хуудас',
      previousPage: 'Өмнөх хуудас',
    },
    table: {
      visibleColumns: 'Харагдах баганууд',
    },
  },

  confirm: {
    strongConfirmInputLabel: 'Батлахын тулд дараах текстийг бичнэ үү: **{{strongConfirmRequiredText}}**',
  },

  dropzone: {
    acceptedFilesMessage:
      '(Зөвхөн {{acceptedExtensions}} өргөтгөлтэй, хамгийн ихдээ {{maxSize}} хэмжээтэй файлуудыг хүлээн авна)',
    error: {
      fileNotValid: 'Сонгосон файл хүчингүй байна',
      fileTooBig: 'Сонгосон файл хэт том байна',
      invalidFileExtension: 'Хүчингүй файлын өргөтгөл: {{extension}}',
    },
    message: 'Файлыг энд чирж оруулах, эсвэл сонгохын тулд дарна уу',
    selectedFile: 'Сонгогдсон файл',
    selectedFile_other: 'Сонгогдсон файлууд',
  },

  error: {
    pageNotFound: 'Хуудас олдсонгүй',
  },

  geo: {
    area: 'Талбай',
    vertices: 'Оройнууд',
    perimeter: 'Периметр',
  },

  files: {
    header: 'Файлууд',
    missing: ' Дутуу файлууд: {{count}}',
    totalSize: 'Нийт хэмжээ: {{size}}',
    fileName: 'Файлын нэр',
    fileSize: 'Файлын хэмжээ',
  },

  sidebar: {
    logout: 'Гарах',
  },

  header: {
    myProfile: 'Миний профайл',
    qrCodeLoginDialog: {
      title: 'Arena Mobile-д QR код ашиглан нэвтрэх',
      instructions: `1. Гар утсан дээрээ **Arena Mobile** аппыг нээнэ үү
2. **Тохиргоо** цэс рүү орно уу
3. **Серверт холбогдох**-ыг сонгоно уу
4. **QR кодоор нэвтрэх**-ийг дарна уу
5. Энэ дэлгэц дээр харагдаж буй QR кодыг уншуулна уу`,
      success: 'Амжилттай нэвтэрлээ!',
      error: 'QR код үүсгэхэд алдаа гарлаа: {{error}}',
    },
  },

  nodeDefsTypes: {
    integer: 'Бүхэл тоо',
    decimal: 'Бутархай тоо',
    text: 'Текст',
    date: 'Огноо',
    time: 'Цаг',
    boolean: 'Боол',
    code: 'Код',
    coordinate: 'Координат',
    geo: 'Газарзүйн',
    taxon: 'Таксон',
    file: 'Файл',
    entity: 'Объект',
  },

  // ====== App modules and views

  appModules: {
    home: 'Нүүр хуудас',
    landing: 'Тавтай морил',
    dashboard: 'Хяналтын самбар',
    surveyNew: 'Шинэ судалгаа',
    surveys: 'Судалгаанууд',
    templateNew: 'Шинэ загвар',
    templates: 'Загварууд',
    usersAccessRequest: 'Хэрэглэгчийн хандалтын хүсэлтүүд',
    collectImportReport: 'Цуглуулгын импортын тайлан',

    surveyInfo: 'Судалгааны мэдээлэл',
    designer: 'Судалгаа',
    formDesigner: 'Маягтын дизайнер',
    surveyHierarchy: 'Иерархи',
    surveyDependencyTree: 'Хамаарлын мод',
    category: 'Ангилал',
    categories: 'Ангилалууд',
    nodeDef: 'Зангилааны тодорхойлолт',
    taxonomy: 'Таксоном',
    taxonomies: 'Таксономууд',

    data: 'Өгөгдөл',
    record: '$t(common.record)',
    records: '$t(common.record_other)',
    recordValidationReport: 'Бичлэгийн баталгаажуулалтын тайлан',
    explorer: 'Хайгч',
    map: 'Газрын зураг',
    charts: 'Графикууд',
    export: 'Өгөгдөл экспортлох',
    import: 'Өгөгдөл импортлох',
    validationReport: 'Баталгаажуулалтын тайлан',

    users: 'Хэрэглэгчид',
    user: 'Хэрэглэгчийн профайл',
    userPasswordChange: 'Нууц үг солих',
    userInvite: 'Хэрэглэгч урих',
    userNew: 'Шинэ хэрэглэгч',
    usersSurvey: 'Хэрэглэгчдийн жагсаалт',
    userGroup: 'Хэрэглэгчийн бүлэг',
    userGroup_plural: 'Хэрэглэгчийн бүлгүүд',
    userGroupNew: 'Шинэ хэрэглэгчийн бүлэг',
    usersList: 'Хэрэглэгчдийн жагсаалт (бүгд)',
    user2FADevice: '2FA төхөөрөмж',
    user2FADevice_plural: '2FA төхөөрөмжүүд',
    user2FADeviceDetails: '$t(appModules.user2FADevice)',
    user2FADeviceList: '$t(appModules.user2FADevice_plural)',

    analysis: 'Шинжилгээ',
    chain: 'Гинж',
    chain_plural: 'Гинжүүд',
    virtualEntity: 'Виртуал объект',
    entities: 'Виртуал объектууд',
    virtualEntity_plural: '$t(appModules.entities)',
    instances: 'Жишээнүүд',

    jobMonitor: 'Ажлын хяналт',

    help: 'Тусламж',
    about: 'Тухай',
    disclaimer: 'Хариуцлагаас татгалзах',
    userManual: 'Хэрэглэгчийн гарын авлага',
  },

  surveyDefsLoader: {
    requireSurveyPublish: 'Энэ хэсэг нь зөвхөн судалгаа нийтлэгдсэн үед л боломжтой.',
  },

  loginView: {
    yourName: 'Таны нэр',
    yourEmail: 'Таны имэйл',
    yourPassword: 'Таны нууц үг',
    yourNewPassword: 'Таны шинэ нууц үг',
    repeatYourPassword: 'Нууц үгээ давтана уу',
    repeatYourNewPassword: 'Шинэ нууц үгээ давтана уу',
    requestAccess: '$t(common.appNameFull)-д шинээр ирсэн үү? Хандалтын хүсэлт илгээх',
    resetPassword: 'Нууц үг сэргээх',
    login: 'Нэвтрэх',
    loginUsingBackupCode: '2FA нөөц кодоор нэвтрэх',
    forgotPassword: 'Нууц үг мартсан',
    sendPasswordResetEmail: 'Нууц үг сэргээх имэйл илгээх',
    twoFactorBackupCode: '2FA нөөц код',
    twoFactorToken: 'Баталгаажуулах код',
    twoFactorTokenDescription: `Таны бүртгэлийг аюулгүй байлгахын тулд бид таныг баталгаажуулна.

  Таны баталгаажуулагч апп-аас үүсгэсэн кодыг оруулна уу.`,
  },

  accessRequestView: {
    error: 'Хандалтын хүсэлт гаргахад алдаа гарлаа: {{error}}',
    fields: {
      email: '$t(common.email)',
      props: {
        firstName: 'Нэр',
        lastName: 'Овог',
        institution: 'Байгууллага',
        country: 'Улс',
        purpose: 'Та юунд ашиглах хэрэгтэй вэ?',
        surveyName: 'Судалгааны нэр санал болгох',
        templateUuid: 'Загвараас эхлэх үү?',
      },
    },
    introduction: `Манай нөөц хязгаарлагдмал тул та платформ руу нэвтрэх хүсэлт гаргах ёстой.
Та юу хийхийг хүсэж байгаагаа бидэнд мэдэгдээрэй!
Та **шинэ хоосон судалгаагаар** эхлэх эсвэл одоо байгаа **загвараас** хувилах боломжтой бөгөөд шинээр үүсгэсэн судалгаанд нэр санал болгох шаардлагатай болно.
Та тухайн судалгааны ***Судалгааны Администратор***-ын үүрэгтэй болно: та үүнийг засах, шинэ хэрэглэгчдийг судалгаандаа урьж, хувь нэмэр оруулах боломжтой болно.
Та мөн ***Судалгааны Менежер*** болно бөгөөд шаардлагатай бол **шинэ судалгаа** (5 хүртэл) үүсгэх боломжтой болно.
Илүү дэлгэрэнгүй мэдээлэл авахыг хүсвэл манай вэбсайтаар зочилно уу: $t(links.openforisArenaWebsite)
$t(common.raiseTicketInSupportForum)
**Хүсэлтээ илгээсний дараа Арена руу нэвтрэх урилгын имэйлийг хүлээгээрэй.**`,
    reCaptchaNotAnswered: 'ReCaptcha хариулагдаагүй',
    requestSent: 'Хандалтын хүсэлт амжилттай илгээгдсэн',
    requestSentMessage: `Таны хүсэлтийг боловсруулахад хэдхэн хоног өгнө үү.
Бид удахгүй **{{email}}** хаяг руу $t(common.appName) руу хэрхэн нэвтрэх тухай заавар бүхий имэйл илгээх болно.
Баярлалаа, **$t(common.appNameFull)**-г ашиглаарай!`,
    sendRequest: 'Хүсэлт илгээх',
    sendRequestConfirm: '$t(common.appNameFull) руу хандах хүсэлт илгээх үү?',
    templateNotSelected: 'Сонгогдоогүй (эхнээс нь эхлэх)',
    title: '$t(common.appNameFull) руу хандах хүсэлт гаргах',
  },

  resetPasswordView: {
    title: {
      completeRegistration: 'Арена дахь бүртгэлээ гүйцээх',
      setYourNewPassword: 'Шинэ нууц үгээ тохируулах',
    },
    setNewPassword: 'Шинэ нууц үг тохируулах',
    forgotPasswordLinkInvalid: 'Таны нэвтрэх гэсэн хуудас байхгүй эсвэл хүчингүй болсон',
    passwordSuccessfullyReset: 'Таны нууц үг амжилттай сэргээгдсэн',
    passwordStrengthChecksTitle: 'Нууц үгийн бат бөх байдлын шалгалт',
    passwordStrengthChecks: {
      noWhiteSpaces: 'Хоосон зай байхгүй',
      atLeast8CharactersLong: 'Наад зах нь 8 тэмдэгтээс бүрдсэн',
      containsLowerCaseLetters: 'Бага үсгүүд агуулсан',
      containsUpperCaseLetters: 'Том үсгүүд агуулсан',
      containsNumbers: 'Тоонууд агуулсан',
    },
    completeRegistration: 'Бүртгэлээ гүйцээх',
  },

  surveyDependencyTreeView: {
    dependencyTypesLabel: 'Хамаарлын төрлүүд',
    dependencyTypes: {
      applicable: 'Хэрэглэх боломжтой',
      defaultValues: 'Үндсэн утгууд',
      editable: 'Засах боломжтой',
      fileName: 'Файлын нэр',
      itemsFilter: 'Элементүүдийн шүүлтүүр',
      maxCount: 'Хамгийн их тоо',
      minCount: 'Хамгийн бага тоо',
      parentCode: 'Эх кодекс',
      validations: 'Баталгаажуулалтууд',
      visible: 'Харагдах',
    },
    selectAtLeastOneDependencyType: 'Наад зах нь нэг хамаарлын төрлийг сонгоно уу',
    noDependenciesToDisplay: 'Харуулах хамаарал байхгүй',
  },

  designerView: {
    formPreview: 'Маягтын урьдчилан харах',
  },

  recordView: {
    justDeleted: 'Энэ бичлэг саяхан устгагдсан',
    sessionExpired: 'Бичлэгийн сесс дууссан',
    errorLoadingRecord: 'Бичлэг ачааллахад алдаа гарлаа: {{details}}',
    recordEditModalTitle: 'Бичлэг: {{keyValues}}',
    recordNotFound: 'Бичлэг олдсонгүй',
    keyAttributeEditing: {
      lock: 'Түлхүүр атрибутын засварыг түгжих',
      unlock: 'Түлхүүр атрибутыг засахыг зөвшөөрөх',
    },
    qualifierAttributeEditing: {
      lock: 'Квалификатор атрибутын засварыг түгжих',
      unlock: 'Квалификатор атрибутыг засахыг зөвшөөрөх',
    },
  },

  dataExplorerView: {
    customAggregateFunction: {
      confirmDelete: 'Энэ өөрчлөн нэгтгэсэн функцийг устгах уу?',
      sqlExpression: 'SQL илэрхийлэл',
    },
    editRecord: 'Бичлэгийг засах',
  },

  mapView: {
    changeMarkerColor: 'Тэмдэглэгээний өнгө өөрчлөх',
    createRecord: 'Шинэ бичлэг үүсгэх',
    editRecord: 'Бичлэгийг засах',
    elevation: 'Өндөр (м)',
    location: 'Байршил',
    locationEditInfo: 'Байршлыг шинэчлэхийн тулд газрын зураг дээр давхар товших эсвэл тэмдэглэгээг чирэх',
    locationNotValidOrOutOfRange: 'Байршил хүчингүй эсвэл UTM бүсийн хязгаараас хэтэрсэн',
    locationUpdated: 'Байршил шинэчлэгдсэн',
    options: {
      showLocationMarkers: 'Байршлын тэмдэглэгээг харуулах',
      showMarkersLabels: `Тэмдэглэгээний шошгыг харуулах`,
      showSamplingPolygon: `Түүвэрлэх олон өнцөгт`,
      showControlPoints: `Хяналтын цэгүүд`,
      showPlotReferencePoint: `Газрын зургийн лавлах цэг`,
      showUtmGrid: 'UTM торыг харуулах',
    },
    samplingPointDataLayerName: 'Түүвэрлэх цэгийн өгөгдөл - түвшин {{level}}',
    samplingPointDataLayerNameLoading: '$t(mapView.samplingPointDataLayerName) (ачаалж байна...)',
    samplingPointItemPopup: {
      title: 'Түүвэрлэх цэгийн элемент',
      levelCode: 'Түвшин {{level}} код',
    },
    selectedPeriod: 'Сонгогдсон хугацаа',
  },

  samplingPolygonOptions: {
    circle: 'Дугуй',
    controlPointOffsetEast: 'Лавлах цэгийн зүүн зүгт шилжилт (м)',
    controlPointOffsetNorth: 'Лавлах цэгийн хойд зүгт шилжилт (м)',
    lengthLatitude: 'Өргөргийн урт (м)',
    lengthLongitude: 'Уртрагийн урт (м)',
    numberOfControlPoints: 'Хяналтын цэгийн тоо',
    numberOfPointsEast: 'Зүүн зүгт хяналтын цэгийн тоо',
    numberOfPointsNorth: 'Хойд зүгт хяналтын цэгийн тоо',
    offsetEast: 'Зүүн зүгт шилжилт (м)',
    offsetNorth: 'Хойд зүгт шилжилт (м)',
    radius: 'Радиус (м)',
    rectangle: 'Тэгш өнцөгт',
    samplingPolygon: 'Түүвэрлэх олон өнцөгт',
    shape: 'Хэлбэр',
  },

  kmlUploader: {
    opacity: 'тунгалаг байдал',
    selectFile: 'Файл сонгох',
    title: 'KML/KMZ/Shapefile сонголтууд',
  },

  mapBaseLayerPeriodSelector: {
    chooseAPeriodToCompareWith: 'Харьцуулах хугацааг сонгоно уу',
    falseColor: 'Худал өнгө',
  },

  surveysView: {
    chains: 'Гинжүүд',
    confirmUpdateSurveyOwner: `Судалгаа "{{surveyName}}"-ийн эзэмшигчийг "{{ownerName}}" болгож өөрчлөх үү?`,
    cycles: 'Мөчлөгүүд',
    datePublished: 'Нийтэлсэн огноо',
    editUserExtraProps: 'Хэрэглэгчийн нэмэлт шинж чанаруудыг засах',
    editUserExtraPropsForSurvey: 'Судалгаа "{{surveyName}}"-ийн хэрэглэгчийн нэмэлт шинж чанаруудыг засах',
    filter: 'Шүүх',
    filterPlaceholder: 'Нэр, шошго эсвэл эзэмшигчээр шүүх',
    languages: 'Хэлнүүд',
    nodes: 'Зангилаанууд',
    noSurveysMatchingFilter: 'Заасан шүүлтүүрт тохирох судалгаа байхгүй',
    onlyOwn: 'Зөвхөн өөрийн судалгаанууд',
    records: 'Бичлэгүүд',
    recordsCreatedWithMoreApps: 'Илүү олон програмаар үүсгэсэн бичлэгүүд:',
    status: {
      published: 'Нийтэлсэн',
      draft: 'Ноорог',
      'published-draft': 'Нийтэлсэн/Ноорог',
    },
  },

  usersAccessRequestView: {
    status: {
      ACCEPTED: 'Хүлээн авсан',
      CREATED: 'Хүлээгдэж байна',
    },
    acceptRequest: {
      accept: 'Хүлээн авах',
      acceptRequestAndCreateSurvey: 'Хүсэлтийг хүлээн авч судалгаа үүсгэх',
      confirmAcceptRequestAndCreateSurvey:
        '**{{email}}**-ийн хандалтын хүсэлтийг **{{role}}**-ын хувиар хүлээн авч, **{{surveyName}}** гэсэн шинэ судалгаа үүсгэх үү?',
      error: 'Хандалтын хүсэлтийг хүлээн авахад алдаа гарлаа: {{error}}',
      requestAcceptedSuccessfully: 'Хандалтын хүсэлтийг амжилттай хүлээн авлаа. $t(common.emailSentConfirmation)',
      surveyLabel: 'Судалгааны шошго',
      surveyLabelInitial: '(Судалгааны нэр, шошгыг шаардлагатай бол өөрчлөх)',
      surveyName: 'Судалгааны нэр',
      template: 'Загвар',
    },
  },

  userView: {
    scale: 'Хэмжээс',
    rotate: 'Эргүүлэх',
    dragAndDrop: 'Зургийг дээр нь чирж оруулах эсвэл',
    upload: 'байршуулахын тулд энд дарна уу',
    sendNewInvitation: 'Шинэ урилга илгээх',
    removeFromSurvey: 'Судалгаанаас хасах',
    confirmRemove: 'Та {{user}}-г {{survey}} судалгаанаас хасахдаа итгэлтэй байна уу?',
    removeUserConfirmation: 'Хэрэглэгч {{user}} нь {{survey}} судалгаанаас хасагдсан',
    maxSurveysUserCanCreate: 'Хэрэглэгчийн үүсгэх боломжтой хамгийн их судалгааны тоо',
    preferredUILanguage: {
      label: 'Хэрэглэгчийн интерфэйсийн хүссэн хэл',
      auto: 'Автоматаар илрүүлсэн ({{detectedLanguage}})',
    },
  },

  userPasswordChangeView: {
    changingPasswordForUser: 'Хэрэглэгчийн нууц үг солих: {{user}}',
    oldPassword: 'Хуучин нууц үг',
    newPassword: 'Шинэ нууц үг',
    confirmPassword: 'Шинэ нууц үгээ баталгаажуулах',
    changePassword: 'Нууц үг солих',
    passwordChangedSuccessfully: 'Нууц үг амжилттай солигдлоо!',
    notAuthorizedToChangePasswordOfAnotherUser: 'Та өөр хэрэглэгчийн нууц үгийг солих эрхгүй байна',
  },

  userInviteView: {
    confirmInviteSystemAdmin: 'Хэрэглэгч {{email}}-г Систем Администратороор урих уу?',
    confirmInviteSystemAdmin_other: 'Хэрэглэгч {{email}}-г Систем Администратороор урих уу?',
    emailSentConfirmationWithSkippedEmails: `$t(common.emailSentConfirmation)

    $t(userInviteView.skippedEmailsNotice)`,
    skippedEmailsNotice: `{{skppedEmailsCount}} хаяг алгассан (тэдгээр нь энэ судалгаанд өмнө нь уригдсан байсан): {{skippedEmails}}`,
    groupPermissions: {
      label: 'Эрхүүд',
      systemAdmin: `
        <li>Системийн бүрэн хандалтын эрх</li>`,
      surveyManager: `
        <li>Судалгаанууд:
          <ul>
            <li>үүсгэх</li>
            <li>хувилах</li>
            <li>өөрийн судалгааг засах</li>
            <li>өөрийн судалгааг устгах</li>
          </ul>
        </li>
        <li>Хэрэглэгчид:
          <ul>
            <li>өөрийн судалгаанд хэрэглэгч урих</li>
          </ul>
        </li>
        $t(userInviteView.groupPermissions.dataAnalyst)`,
      surveyAdmin: `
        <li>Судалгаанууд:
          <ul>
            <li>хувилах</li>
            <li>өөрийн судалгааг засах</li>
            <li>өөрийн судалгааг устгах</li>
          </ul>
        </li>
        <li>Хэрэглэгчид:
          <ul>
            <li>өөрийн судалгаанд хэрэглэгч урих</li>
          </ul>
        </li>
        $t(userInviteView.groupPermissions.dataAnalyst)`,
      surveyEditor: `
        <li>Судалгаанууд:
          <ul>
            <li>өөрийн судалгааг засах</li>
          </ul>
        </li>
        $t(userInviteView.groupPermissions.dataAnalyst)`,
      dataAnalyst: `
        <li>Өгөгдөл:
          <ul>
            $t(userInviteView.groupPermissions.dataCleanserData)
            <li>Газрын зургийн хэрэгсэлд хандах</li>
          </ul>
        </li>
        <li>Шинжилгээ:
          <ul>
            <li>бүх хэрэгсэлд бүрэн хандалтын эрх</li>
          </ul>
        </li>`,
      dataCleanser: `
        <li>Өгөгдөл:
          <ul>
            $t(userInviteView.groupPermissions.dataCleanserData)
          </ul>
        </li>`,
      dataCleanserData: `
        $t(userInviteView.groupPermissions.dataEditorData)
        <li>өгөгдлийн баталгаажуулалтын хэрэгсэлд хандах</li>
        <li>бичлэгүүдийг "Шинжилгээ" үе шат руу илгээх</li>`,
      dataEditor: `
        <li>Өгөгдөл:
          <ul>$t(userInviteView.groupPermissions.dataEditorData)</ul>
        </li>`,
      dataEditorData: `
        <li>шинэ бичлэг нэмэх (өөрийн судалгаанууд)</li>
        <li>одоо байгаа бичлэгүүдийг засах (өөрийн судалгаанууд)</li>
        <li>бичлэгүүдийг "Цэвэрлэгээ" үе шат руу илгээх</li>`,
    },
    messageOptional: 'Мессеж (заавал биш)',
    messageInfo: `Мессеж нь хэрэглэгч рүү илгээгдсэн имэйлд харагдана.
Энэ нь энгийн текст эсвэл Markdown хэл байж болно (https://www.markdownguide.org).`,
    sendInvitation: 'Урилга илгээх',
    surveyNotPublishedWarning: `**Анхааруулга**: судалгаа нийтлэгдээгүй байна.
      Хэрэглэгчдийг зөвхөн ***$t(auth:authGroups.systemAdmin.label)*** болон ***$t(auth:authGroups.surveyAdmin.label)*** үүргээр урих боломжтой.
      Хэрэв та өөр үүрэгтэй хэрэглэгчдийг урихыг хүсвэл эхлээд судалгаагаа нийтлэх хэрэгтэй.`,
    typeEmail: 'Имэйл хаягийг бичээд, Нэмэх товчийг дарна уу',
  },

  user: {
    mapApiKeys: {
      title: 'Газрын зураг API түлхүүрүүд',
      mapProviders: {
        planet: 'Планет',
      },
      keyIsCorrect: 'Энэ API түлхүүр хүчинтэй',
      keyIsNotCorrect: 'Энэ API түлхүүр ХҮЧИНГҮЙ',
    },
    title: 'Цол',
    titleValues: {
      mr: 'Ноён',
      ms: 'Хатагтай',
      preferNotToSay: 'Хэлэхгүй байхыг хүсэж байна',
    },
  },

  chainView: {
    baseUnit: {
      confirmDelete:
        'Суурь нэгжийг устгаснаар та бүх "талбай дээр суурилсан хувьсагч" сонголтуудыг болино. Үргэлжлүүлэх үү?',
    },
    downloadSummaryJSON: 'Хураангуй татах (JSON)',
    firstPhaseCategory: '1-р үе шатны ангилал',
    firstPhaseCategoryInfo: '1-р үе шатны түүврийг агуулсан ангиллыг сонгоно уу.',
    firstPhaseCategoryExtraProp: {
      label: '1-р үе шатны давхаргын шинж чанар',
      info: 'Анхны популяцийг эхний түүврийн шатанд өргөн давхаргад хуваахад ашиглах хувьсагчийг сонгоно уу.',
    },
    firstPhaseCommonAttribute: {
      label: 'Нийтлэг шинж чанар',
      info: `Суурь нэгж ба 1-р үе шатны хүснэгтийн хоорондох нийтлэг шинж чанар
(энэ нь 1-р үе шатны ангилалд тодорхойлогдсон нэмэлт шинж чанарын ижил нэртэй кодын шинж чанар байх ёстой)`,
    },
    formLabel: 'Боловсруулах гинжийн шошго',
    basic: 'Үндсэн',
    records: 'Бичлэгүүд',
    recordsInStepCount: '{{step}}: {{recordsCount}}',
    submitOnlyAnalysisStepDataIntoR: 'Зөвхөн шинжилгээний алхамын өгөгдлийг RStudio руу илгээх',
    submitOnlySelectedRecordsIntoR: 'Зөвхөн сонгогдсон бичлэгүүдийг RStudio руу илгээх',
    includeEntitiesWithoutData: 'Өгөгдөлгүй объектуудыг оруулах',
    cannotStartRStudio: {
      common: 'RStudio-г эхлүүлэх боломжгүй',
      noRecords: '$t(chainView.cannotStartRStudio.common): илгээх бичлэг байхгүй',
      surveyNotPublished: '$t(chainView.cannotStartRStudio.common): эхлээд судалгааг нийтлэх',
    },
    nonResponseBiasCorrection: 'Хариу өгөхгүй байх хазайлт засварлах',
    nonResponseBiasCorrectionInfo: `Жинлэлтийн ангиллын тохируулгын аргыг хэрэгжүүлэхийн тулд 'design_psu' болон 'design_ssu'-г давхаргын ангиллын хүснэгтэд нэмэлт тоон шинж чанар болгон нэмнэ үү.`,
    pValue: 'P-утга',
    resultsBackFromRStudio: 'RStudio-оос үр дүнг буцааж уншсан',
    resultsBackFromRStudioInfo: `RStudio-д тооцоолсон үр дүнгийн шинж чанаруудыг Arena сервер рүү буцааж импортлох шаардлагатай бол энэ сонголтыг идэвхжүүлнэ үү.
Энэ үйл явц удаан байж болзошгүй.`,
    samplingDesign: 'Түүвэрлэлтийн загвар',
    samplingDesignDetails: 'Түүвэрлэлтийн загварын дэлгэрэнгүй мэдээлэл',
    samplingStrategyLabel: 'Түүвэрлэлтийн стратеги',
    samplingStrategy: {
      simpleRandom: 'Энгийн санамсаргүй түүвэрлэлт',
      systematic: 'Системчилсэн түүвэрлэлт',
      stratifiedRandom: 'Үечилсэн санамсаргүй түүвэрлэлт',
      stratifiedSystematic: 'Үечилсэн системчилсэн түүвэрлэлт',
      twoPhase: 'Хоёр үе шаттай түүвэрлэлт',
    },
    statisticalAnalysis: {
      header: 'Статистик шинжилгээ',
      entityToReport: 'Тайлагнах объект',
      entityWithoutData: 'Объект {{name}} өгөгдөлгүй байна',
      filter: 'Шүүлтүүр (R скрипт)',
      reportingMethod: 'Тайлагнах арга',
      reportingMethods: {
        dimensionsCombined: 'Хэмжээсүүдийг нэгтгэсэн',
        dimensionsSeparate: 'Хэмжээсүүдийг тусад нь',
      },
      reportingArea: 'Нийт тайлагнах талбай (га) (Заавал биш)',
      reportingAreaInfo: `Үечилсэн түүвэрлэлтийн хувьд үечилсэн шинж чанарын ангиллын хүснэгтэд давхаргуудын талбайг оруулна уу (баганын нэр 'area')`,
    },
    stratumAttribute: 'Үеийн шинж чанар',
    stratumAttributeInfo: 'Түүврийг давхаргад хуваахад ашиглах хувьсагчийг сонгоно уу.',
    stratumAttribute2ndPhase: '2-р үе шатны давхаргын шинж чанар',
    stratumAttribute2ndPhaseInfo: `Эцсийн, дэлгэрэнгүй дэд түүврийг гаргаж авахаас өмнө 1-р үе шатны түүврийг дэд давхаргад хуваахад ашиглах хувьсагчийг сонгоно уу.`,
    postStratificationAttribute: 'Дараах үечилсэн шинж чанар',
    areaWeightingMethod: 'Талбайн жинлэх арга',
    clusteringEntity: 'Бүлэглэх объект',
    clusteringEntityInfo: `Анхдагч түүврийн нэгжийг тодорхойлох объект. Тэмдэглэл: Энэ нь зөвхөн R survey багцын хүрээнд кластерийн шинжилгээнд ашиглагдана.`,
    clusteringOnlyVariances: 'Зөвхөн хэлбэлзэлд зориулсан бүлэглэлт',
    errorNoLabel: 'Гинж нь хүчинтэй шошготой байх ёстой',
    dateExecuted: 'Гүйцэтгэсэн огноо',
    deleteChain: 'Гинжийг устгах',
    deleteConfirm: `Энэ боловсруулах гинжийг устгах уу?
    
$t(common.cantUndoWarning)`,
    deleteComplete: 'Боловсруулах гинж устгагдсан',
    cloneFromAnotherSurvey: 'Өөр судалгаанаас хуулах',
    cloneFromAnotherSurveyDialog: {
      title: 'Өөр судалгаанаас гинжийг хуулах',
      sourceSurvey: 'Эх судалгаа',
      sourceChain: 'Эх гинж',
      entityCheck: 'Объектын нийцтэй байдал',
      entityMissing: 'зорилтот судалгаанд байхгүй',
      noAnalysisAttributes: 'Энэ гинж шинжилгээний шинж чанаргүй байна',
      cloneComplete: 'Гинж амжилттай хуулагдсан',
      missingEntities: 'Хуулах боломжгүй: дараах объектууд зорилтот судалгаанд байхгүй байна: {{entities}}',
    },
    cannotSelectNodeDefNotBelongingToCycles: `Зангилааны тодорхойлолт "{{label}}" нь боловсруулах гинжийн бүх мөчлөгт хамаарахгүй тул сонгох боломжгүй.`,
    cannotSelectCycle:
      'Энэ мөчлөгийг сонгох боломжгүй, учир нь зарим зангилааны тодорхойлолтууд энэ мөчлөгт хамаарахгүй.',
    copyRStudioCode: `#### Та RStudio Сервер нээх гэж байна ####
##### ОК товчийг дарна уу, энэ командуудыг таны санах ойд хуулах болно. #####
###### RStudio Сервер нээгдэх болно; RStudio консол идэвхжсэн үед дараах мөрүүдийг хуулж гүйлгэж гинжийн кодыг импортлоно уу: ######
{{rStudioCode}}
`,
    copyRStudioCodeLocal: `#### RStudio руу боловсруулах гинж ####
###### ОК товчийг дарна уу, энэ командуудыг таны санах ойд хуулах болно. ######
###### Өөрийн машин дээр RStudio-г эхлүүлнэ үү (та 'rstudioapi' багц суулгасан байх ёстой). ######
###### RStudio консол идэвхжсэн үед дараах мөрүүдийг хуулж гүйлгэж гинжийн кодыг импортлоно уу: ######
{{rStudioCode}}
`,
    entities: {
      new: 'Виртуал объект',
    },
    reportingDataCategory: 'Тайлагнах өгөгдлийн ангиллын хүснэгтийн нэр',
    reportingDataAttribute: '{{level}}-д зориулсан шинж чанар',
    reportingDataTableAndJoinsWithAttributes: 'Тайлагнах өгөгдлийн хүснэгт болон шинж чанаруудтай нэгдэл',
    showSamplingAttributes: 'Түүвэрлэх шинж чанаруудыг харуулах',
  },

  instancesView: {
    title: 'Жишээнүүд',
    terminate: 'Дуусгах',
  },
  chain: {
    quantitative: 'Тоон',
    categorical: 'Ангиллын',
    addQuantitative: 'Тоон шинж чанар нэмэх',
    addCategorical: 'Ангиллын шинж чанар нэмэх',
    emptyNodeDefs: '$t(validationErrors:analysis.analysisNodeDefsRequired)',
    entityExcludedInRStudioScripts:
      'объект болон түүнтэй холбоотой бүх үр дүнгийн хувьсагчид RStudio скриптүүдэд хасагдана',
    entityWithoutData: 'Объект {{name}} өгөгдөлгүй байна; $t(chain.entityExcludedInRStudioScripts)',
    entityNotInCurrentCycle: 'Объект {{name}} нь сонгогдсон мөчлөгт байхгүй; $t(chain.entityExcludedInRStudioScripts)',
    error: {
      invalidToken: 'Хүчингүй эсвэл хугацаа нь дууссан токен',
    },
  },

  itemsTable: {
    unused: 'Ашиглагдаагүй',
    noItemsAdded: 'Элемент нэмэгдээгүй',
  },

  expression: {
    functionHasTooFewArguments: 'Функц {{fnName}}-д наад зах нь {{minArity}} аргумент шаардлагатай ({{numArgs}} авсан)',
    functionHasTooManyArguments:
      'Функц {{fnName}} нь хамгийн ихдээ {{maxArity}} аргумент хүлээн авдаг ({{numArgs}} авсан)',
    identifierNotFound: 'Шинж чанар эсвэл объект "{{name}}" олдсонгүй',
    invalid: 'Хүчингүй илэрхийлэл: {{details}}',
    invalidAttributeValuePropertyName: 'Хүчингүй шинж чанарын утгын шинж чанарын нэр: {{attributeName}}.{{propName}}',
    invalidCategoryExtraProp: 'Хүчингүй нэмэлт шинж чанарын нэр: {{propName}}',
    invalidCategotyName: 'Хүчингүй ангиллын нэр: {{name}}',
    invalidTaxonomyExtraProp: 'Хүчингүй таксономын нэмэлт шинж чанарын нэр: {{propName}}',
    invalidTaxonomyName: 'Хүчингүй таксономын нэр: {{name}}',
    invalidTaxonVernacularNameLanguageCode: 'Хүчингүй таксоны нутгийн нэрийн хэлний код: {{vernacularLangCode}}',
    missingFunctionParameters: 'Функцын дутуу параметрүүд',
    undefinedFunction: 'Тодорхойгүй функц: {{name}}',
  },

  // ====== Help views
  helpView: {
    about: {
      text: `
Тухай
========

$t(common.appNameFull)
--------
 
 * Хөгжүүлсэн: $t(links.openforis)
 * Хувилбар: {{version}}
 * Вэбсайт: $t(links.openforisArenaWebsite)
 * Arena видео хичээлүүд FAO elearning Академид: $t(links.arenaVideoTutorialsInFaoElearningAcademy)
 * Arena видео хичээлүүд YouTube-д: $t(links.arenaVideoTutorialsInYouTube)
 * Дэмжлэгийн форум: $t(links.supportForum)
 * Arena GitHub-д: $t(links.arenaInGitHub)
 * Arena R Скриптүүд GitHub-д: $t(links.arenaRScriptsInGitHub)
`,
    },
  },

  // ====== Survey views

  nodeDefEdit: {
    additionalFields: 'Нэмэлт талбарууд',
    basic: 'Үндсэн',
    advanced: 'Нарийвчилсан',
    mobileApp: 'Мобайл апп',
    print: 'Хэвлэх',
    printProps: {
      printOrientation: {
        label: 'Хуудасны чиглэл',
        info: 'Энэ объект өөрийн хэвлэх хэсгийг эхлүүлэхэд ашиглагдах чиглэл. Анхдагчаар экспортод сонгосон баримтын чиглэлийг дагана.',
      },
      orientations: {
        default: 'Анхдагч (баримт)',
        portrait: 'Босоо',
        landscape: 'Хэвтээ',
      },
    },
    validations: 'Баталгаажуулалтууд',
    function: 'Функц',
    editingFunction: 'Функц {{functionName}}-г засах',
    editorHelp: {
      json: 'Хүчинтэй илэрхийлэл нь Javascript-ийн дэд олонлог юм.',
      sql: 'Зөвхөн хүчинтэй SQL илэрхийллийг зөвшөөрнө.',
    },
    editorCompletionHelp: '- Боломжтой хувьсагчид болон ашиглаж болох функцуудыг харуулах',
    functionDescriptions: {
      categoryItemProp: 'Заасан кодтой ангиллын элементийн заасан $t(extraProp.label)-ийн утгыг буцаана',
      dateTimeDiff: '2 огноо-цагийн хоорондох ялгааг (минутаар) буцаана',
      distance: 'Заасан координатуудын хоорондох зайг (метрээр) буцаана',
      geoCoordinateAtDistance: 'Заасан координатаас тодорхой зай болон чиглэлд байрлах координатыг буцаана',
      geoDistance: '$t(nodeDefEdit.functionDescriptions.distance)',
      first: 'Заасан олон шинж чанар эсвэл объектын эхний утга эсвэл зангилааг буцаана',
      geoPolygon: 'Координатуудын жагсаалтаас GeoJSON-д олон өнцөгт үүсгэнэ',
      includes: 'Заасан олон шинж чанар заасан утгыг агуулсан бол үнэн буцаана.',
      index: 'Заасан зангилааны ах дүүсийнх нь доторх индексийг буцаана',
      isEmpty: 'Хэрэв аргумент утгагүй бол үнэн буцаана',
      isNotEmpty: 'Хэрэв аргумент ямар нэгэн утгатай бол үнэн буцаана',
      last: 'Заасан олон шинж чанар эсвэл объектын сүүлийн утга эсвэл зангилааг буцаана',
      ln: 'X-ийн натурал логарифмыг буцаана',
      log10: 'X-ийн 10-н суурьтай логарифмыг буцаана',
      max: 'Аргументуудын хамгийн их утгыг буцаана',
      min: 'Аргументуудын хамгийн бага утгыг буцаана',
      now: 'Одоогийн огноо эсвэл цагийг буцаана',
      parent: 'Заасан зангилааны эцэг объектыг буцаана',
      pow: 'Суурийн утгыг зэрэгт өргөсөн утгыг буцаана',
      prevCycleNote:
        'Зөвхөн Arena Mobile-д ажилладаг, олон мөчлөг тодорхойлогдсон бөгөөд өмнөх мөчлөгтэй холбоос идэвхжүүлсэн үед',
      prevCycleValue:
        'Өмнөх мөчлөгийн бичлэгт ижил шинж чанарын утгыг буцаана. $t(nodeDefEdit.functionDescriptions.prevCycleNote)',
      prevCycleValues:
        'Өмнөх мөчлөгийн бичлэгт ижил шинж чанаруудын утгуудыг буцаана. $t(nodeDefEdit.functionDescriptions.prevCycleNote)',
      recordCycle: 'Одоогийн бичлэгийн мөчлөгийг буцаана',
      recordDateCreated:
        'Одоогийн бичлэгийн үүсгэсэн огноо, цагийг datetime утгаар буцаана. Үүнийг текст, огноо эсвэл цагийн шинж чанарт ашиглаж болно',
      recordDateLastModified:
        'Одоогийн бичлэгийн сүүлд өөрчилсөн огноо, цагийг datetime утгаар буцаана. Үүнийг текст, огноо эсвэл цагийн шинж чанарт ашиглаж болно',
      recordOwnerEmail: 'Бичлэгийг эзэмшигч хэрэглэгчийн имэйлийг буцаана',
      recordOwnerName: 'Бичлэгийг эзэмшигч хэрэглэгчийн нэрийг буцаана',
      recordOwnerRole: 'Бичлэгийг эзэмшигч хэрэглэгчийн үүргийг (одоогийн судалгаанд) буцаана',
      rowIndex: 'Одоогийн хүснэгтийн мөрний (эсвэл маягтын) индексыг буцаана',
      taxonProp: 'Заасан кодтой таксоны заасан $t(extraProp.label)-ийн утгыг буцаана',
      taxonVernacularName: 'Заасан кодтой таксоны заасан хэлээрх (эхний) нутгийн нэрийг буцаана',
      userEmail: 'Нэвтэрсэн хэрэглэгчийн имэйлийг буцаана',
      userIsRecordOwner:
        'Бичлэгийг засаж буй хэрэглэгч нь мөн түүний эзэмшигч бол "үнэн", үгүй бол "худал" гэсэн боол утгыг буцаана',
      userName: 'Нэвтэрсэн хэрэглэгчийн нэрийг буцаана',
      userProp: 'Нэвтэрсэн хэрэглэгчийн заасан $t(extraProp.label)-ийн утгыг буцаана',
      uuid: 'UUID (бүх нийтийн өвөрмөц танигч)-г үүсгэнэ, үүнийг танигч болгон ашиглаж болно (жишээ нь, объектын түлхүүр шинж чанар болгон)',
      // SQL functions
      avg: 'Тоон хувьсагчийн дундаж утгыг буцаана',
      count: 'Заасан шалгуурт тохирох мөрүүдийн тоог буцаана',
      sum: 'Тоон хувьсагчийн нийт нийлбэрийг буцаана',
    },
    functionName: {
      rowIndex: 'Мөрийн индекс',
    },
    basicProps: {
      analysis: 'Шинжилгээ',
      autoIncrementalKey: {
        label: 'Автомат өсөн нэмэгдэх түлхүүр',
        info: 'Утга автоматаар үүсгэгдэнэ',
      },
      autoCreateMinCountItems: {
        label: 'Хамгийн бага элементийг автоматаар үүсгэх',
        info: 'Объект хэрэгжиж эхлэх үед эсвэл түүний эцэг объект үүсгэгдэх үед хамгийн бага тооны объектууд автоматаар үүсгэгдэнэ.',
      },
      displayAs: 'Илэрхийлэх',
      displayIn: 'Илэрхийлэхдээ',
      entitySource: 'Объектын эх үүсвэр',
      enumerate: {
        label: 'Тоолох',
        info: `Мөрүүд нь объектын дотор тодорхойлогдсон Түлхүүр гэж тэмдэглэгдсэн кодын шинж чанартай холбоотой ангиллын элементүүдийг ашиглан автоматаар үүсгэгдэнэ; мөр нэмэх эсвэл устгах боломжгүй бөгөөд түлхүүр кодын шинж чанарыг засах боломжгүй`,
      },
      enumerator: {
        label: 'Тоологч',
        info: 'Ангиллын элементүүд эцэг объектын мөрүүдийг үүсгэхэд ашиглагдана',
      },
      form: 'Маягт',
      formula: 'Томьёо',
      includedInClonedData: 'Хувилах өгөгдөлд оруулсан',
      includedInRecordsList: {
        label: 'Бүртгэлийн жагсаалтад оруулах',
        info: `Хэрэв тэмдэглэсэн бол уг шинж чанар нь бүртгэлийн жагсаалтад харагдах болно`,
      },
      key: 'Түлхүүр',
      maxKeysCountReached: 'Түлхүүрийн дээд тоо хүрсэн ({{maxKeysCount}})',
      multiple: 'Олон',
      ownPage: 'Өөрийн хуудас',
      parentPage: 'Эцэг хуудас ({{parentPage}})',
      qualifier: {
        label: 'Тодорхойлогч',
        info: `Бүлэгт харьяалагддаг хэрэглэгч шинэ бичлэг үүсгэхэд энэ атрибут нь хэрэглэгчийн бүлгийн тодорхойлогчид заасан утгаар автоматаар бөглөгдөнө. Хэрэглэгчид зөвхөн өөрийн бүлэгт хамаарах бичлэгүүдийг харах, засах боломжтой байх болно, хэрэв тэд бүлэгт харьяалагддаг бол.`,
      },
      table: 'Хүснэгт',
    },
    advancedProps: {
      defaultValuesNotSpecified: 'Үндсэн утгууд тодорхойлогдоогүй',
      defaultValuesSpecified: 'Үндсэн утгууд тодорхойлогдсон',
      editableAlways: 'Үргэлж засварлах боломжтой',
      editableIfConditionIsMet: 'Нөхцөл биелсэн үед засварлах боломжтой',
      relevantIfRadioNone: 'Үргэлж хамааралтай',
      relevantIfRadioDefined: 'Нөхцөл биелсэн үед хамааралтай',
      visibleAlways: 'Үргэлж харагдах',
      visibleIfConditionIsMet: 'Нөхцөл биелсэн үед харагдах',
      areaBasedEstimate: 'Талбай дээр суурилсан тооцоо',
      defaultValues: 'Үндсэн утгууд',
      defaultValuesInfo: `Энэ нь тодорхой дүрмийн дагуу хариуг автоматаар бөглөх боломжийг олгоно.
    Хэрэв хэд хэдэн дүрэм тохируулсан бол систем тэдгээрийг дээрээс доош дарааллаар шалгана.
    Нөхцөлд нийцсэн эхний дүрмийг хэрэглэж, түүний үр дүнг хариу болгон ашиглана.`,
      defaultValueEvaluatedOneTime: 'Үндсэн утга нэг удаа үнэлэгдсэн',
      defaultValueEvaluatedOneTimeInfo: `Шинж чанар үүсэх үед үндсэн утгыг зөвхөн нэг удаа үнэлнэ.
    Хэрэв тэмдэглээгүй бол бичлэг шинэчлэх бүрт үндсэн утгыг дахин үнэлнэ.
    now() эсвэл uuid() зэрэг зөвхөн нэг удаа үнэлэгдэх ёстой илэрхийллүүдийг ашиглах үед үүнийг тэмдэглэх хэрэгтэй.`,
      defaultValuesNotEditableForAutoIncrementalKey:
        'Автоматаар өсөн нэмэгдэх түлхүүр тохируулагдсан тул үндсэн утгуудыг засах боломжгүй',
      editableIf: 'Хэрэв засварлах боломжтой бол',
      editableIfInfo: `Анхдагчаар хэрэглэгч хамааралтай талбарт үргэлж хандах боломжтой.
Энд хэрэглэгч энэ талбарт бичих эсвэл утгыг өөрчлөх эсэхийг тодорхойлох дүрэм тохируулж болно.
Энэ нь хэрэглэгч энэ талбарт бичих эсвэл утгыг өөрчлөх боломжтой эсэхийг шийднэ.
    Хэрэв таны тохируулсан нөхцөл биелбэл талбарыг засварлаж болно. Үгүй бол зөвхөн унших (түгжигдсэн) болно.`,
      hidden: 'Үргэлж нуух',
      hiddenInReport: 'Аналитик хяналтын самбарт нуух',
      hiddenInReportInfo: `Хэрэв тэмдэглэгдсэн бол шинж чанар Аналитик хяналтын самбарт харагдахгүй`,
      hiddenWhenNotRelevant: 'Хамааралгүй үед нуух',
      itemsFilter: 'Элементүүдийн шүүлтүүр',
      itemsFilterInfo: `Сонгогдох элементүүдийг шүүхэд ашиглагдах илэрхийлэл.
Илэрхийлэлд "this" гэдэг үг нь элементийг өөрийг нь заана.
Жишээ нь: this.region = region_attribute_name
(энд "region" нь элементийн хувьд тодорхойлогдсон нэмэлт шинж чанарын нэр, region_attribute_name нь судалгаан дахь шинж чанарын нэр юм)`,
      readOnly: 'Зөвхөн унших',
      relevantIf: 'Хэрэв хамааралтай бол',
      relevantIfInfo: `Анхдагчаар бүх талбар идэвхтэй байна.
    Хэрэв хамааралтын дүрэм тохируулж, тэр нь биелэхгүй бол талбар саарал болох эсвэл бүрэн нуугдана,
    мөн автомат хариунуудыг үл тоомсорлоно.
    Үүнийг маягтын хэсгийг динамикаар харуулах/нуухад ашиглана; жишээ нь хэрэглэгч "Бусад" сонгосон үед л "Тодруулна уу" талбарыг харуулах.`,
      script: 'Скрипт',
      visibleIf: 'Хэрэв харагдах бол',
      visibleIfInfo: `Анхдагчаар талбар үргэлж харагдана.
    Хэрэв дүрэм тохируулбал, тэр дүрэм биелсэн үед л харагдана; эс тэгвээс нуугдана.
    Тэмдэглэл: "хамааралгүй" талбарыг нуухаас ялгаатай нь, нуугдсан талбар автомат хариуг хадгалж болно.
    Энэ нь хэн нэвтэрснээс (жишээ нь үүргээс) хамаарч маягтын бүхэл хэсгийг нуухад тохиромжтой.`,
    },
    mobileAppProps: {
      hiddenInMobile: {
        label: 'Арена Мобайл-д нуугдсан',
        info: `Хэрэв тэмдэглэгдсэн бол шинж чанар AM-д харагдахгүй`,
      },
      includedInMultipleEntitySummary: {
        label: 'Олон объектын хураангуйд оруулах',
        info: `Хэрэв тэмдэглэгдсэн бол шинж чанар объектын хураангуй харагдацад харагдана`,
      },
      includedInPreviousCycleLink: {
        label: 'Өмнөх мөчлөгийн холбоосонд оруулах',
        info: `Хэрэв тэмдэглэгдсэн бол өмнөх мөчлөгийн утга өгөгдөл оруулах маягт дээр харагдана (мобайл апп-д өмнөх мөчлөгт холбоос идэвхтэй үед)"`,
      },
    },
    numericProps: {
      unit: 'Нэгж',
    },
    decimalProps: {
      maxNumberDecimalDigits: 'Бутархай тооны хамгийн их орон',
    },
    fileProps: {
      fileNameExpression: 'Файлын нэрийн илэрхийлэл',
      fileType: 'Файлын төрөл',
      fileTypes: {
        image: 'Зураг',
        video: 'Видео',
        audio: 'Аудио',
        other: 'Бусад',
      },
      maxFileSize: 'Хамгийн их файлын хэмжээ (МБ)',
      numberOfFiles: 'Хамгийн бага болон хамгийн их файлын тоог өөрчлөхийн тулд Баталгаажуулалт руу орно уу.',
      showGeotagInformation: 'Газарзүйн мэдээллийг харуулах',
    },
    mobileProps: {
      title: 'Мобайл апп',
    },
    formHeaderProps: {
      headerColorLabel: 'Толгой хэсгийн өнгө',
      headerColor: {
        blue: 'Цэнхэр',
        green: 'Ногоон',
        orange: 'Улбар шар',
        red: 'Улаан',
        yellow: 'Шар',
      },
    },
    textProps: {
      displayAsTypes: {
        hyperlink: 'Гиперлинк',
        markdown: 'Markdown',
        text: 'Текст',
      },
      textInputType: 'Текстийн оролтын төрөл',
      textInputTypes: {
        singleLine: 'Нэг мөр',
        multiLine: 'Олон мөр',
      },
      textTransform: 'Текстийн хувиргалт',
      textTransformTypes: {
        none: 'байхгүй',
        capitalize: 'том үсгээр эхлэх',
        uppercase: 'том үсгээр',
        lowercase: 'бага үсгээр',
      },
    },
    booleanProps: {
      labelValue: 'Шошгын утга',
      labelValues: {
        trueFalse: '$t(common.true)/$t(common.false)',
        yesNo: '$t(common.yes)/$t(common.no)',
      },
    },
    codeProps: {
      category: 'Ангилал',
      codeShown: 'Кодыг харуулах',
      displayAsTypes: {
        checkbox: 'Чекбокс',
        dropdown: 'Дропдаун',
      },
      parentCode: 'Эх код',
    },
    coordinateProps: {
      allowOnlyDeviceCoordinate: 'Зөвхөн төхөөрөмжийн координатыг зөвшөөрөх',
      allowOnlyDeviceCoordinateInfo: `Зөвхөн Арена Мобайл-д хамаарна: хэрэв шалгагдсан бол хэрэглэгч X/Y утгуудыг өөрчлөх боломжгүй, зөвхөн төхөөрөмжийн GPS-г ашиглан тэдгээрийг авах боломжтой`,
      mapMarkerColor: 'Газрын зураг дээрх тэмдэглэгээний өнгө',
    },
    expressionsProp: {
      expression: 'Илэрхийлэл',
      applyIf: 'Хэрэв хэрэглэх бол',
      confirmDelete: 'Энэ илэрхийллийг устгах уу?',
      severity: 'Хүндрэл',
    },
    validationsProps: {
      minCount: 'Хамгийн бага тоо',
      maxCount: 'Хамгийн их тоо',
      expressions: 'Баталгаажуулалтын илэрхийлэл',
      attributeAlwaysValid: 'Шинж чанар үргэлж хүчинтэй',
      attributeValidWhenConditionIsMet: 'Нөхцөл биелсэн үед шинж чанар хүчинтэй',
    },
    cannotChangeIntoMultipleWithDefaultValues: 'Энэ зангилааг үндсэн утгуудтай олон болгох боломжгүй.',
    cannotDeleteNodeDefReferenced: `Зангилааны тодорхойлолт "{{nodeDef}}"-г устгах боломжгүй: энэ нь дараах зангилааны тодорхойлолтуудаар холбогдсон байна: {{nodeDefDependents}}`,
    cloneDialog: {
      confirmButtonLabel: 'Хувилах',
      title: 'Зангилааны тодорхойлолт "{{nodeDefName}}"-г хувилах',
      entitySelectLabel: 'Хувилах объект:',
    },
    conversion: {
      dialogTitle: '{{nodeDefName}}-г өөр төрөл болгон хөрвүүлэх',
      fromType: 'Эхний төрөл',
      toType: 'Хүртэлх төрөл',
    },
    moveDialog: {
      confirmButtonLabel: 'Шилжүүлэх',
      title: '"{{parentNodeDefName}}" -аас "{{nodeDefName}}" зангилааны тодорхойлолтыг зөөж байна',
      entitySelectLabel: 'Шилжүүлэх объект:',
    },
    movedNodeDefinitionHasErrors: 'Таны шилжүүлсэн зангилааны тодорхойлолт "{{nodeDefName}}" алдаатай байна; засна уу.',
    nodeDefintionsHaveErrors: 'Эдгээр зангилааны тодорхойлолтууд алдаатай байна: {{nodeDefNames}}. Засна уу.',
    filterVariable: 'Элементүүдийг шүүх хувьсагч',
    filterVariableForLevel: 'Түвшин {{levelName}}-д зориулсан хувьсагч',
    unique: {
      label: 'Өвөрмөц',
      info: `Шинж чанарыг **Өвөрмөц** гэж тэмдэглэсэн үед түүний утга нь хамгийн ойрын олон объектын дотор өвөрмөц байх ёстой (эсрэгээр нь алдаа гарна).

---

Жишээ нь, *бүлэглэл -> талбай -> мод* гэсэн бүтэцтэй бол, хэрэв танд **Өвөрмөц** гэж тэмдэглэгдсэн *tree_species* гэсэн шинж чанар байвал, нэг *талбай* дотор зөвхөн нэг төрлийн мод байж болно.`,
    },
    categoriesClonedFromSurvey: 'Дараах ангилалууд эх судалгаанаас мөн хувилагдсан: {{names}}',
    taxonomiesClonedFromSurvey: 'Дараах таксономууд эх судалгаанаас мөн хувилагдсан: {{names}}',
  },

  languagesEditor: {
    languages: 'Хэл(нүүд)',
  },

  taxonomy: {
    header: 'Таксоном',
    cantBeDeleted: `$t(common.cantBeDeletedUsedItem, {'item': 'taxonomy'})`,
    confirmDelete: 'Таксоном {{taxonomyName}}-г устгах уу?\n$t(common.cantUndoWarning)',
    cloneFromAnotherSurvey: {
      title: 'Өөр судалгаанаас таксоном хуулах',
      sourceSurvey: 'Эх сурвалж судалгаа',
      sourceTaxonomy: 'Эх сурвалж таксоном',
      loadingSurveys: 'Судалгаанууд ачаалж байна...',
      noSurveysAvailable: 'Судалгаа алга байна',
      selectSurveyFirst: 'Эхлээд судалгаа сонгоно уу',
      loadingTaxonomies: 'Таксоном ачаалж байна...',
      noTaxonomiesAvailable: 'Сонгосон судалгаанд таксоном алга байна',
    },
    edit: {
      taxonomyListName: 'Таксономын жагсаалтын нэр',
      taxaNotImported: 'Таксонуудыг импортлоогүй',
      family: 'Овог',
      genus: 'Төрөл',
      scientificName: '$t(surveyForm:nodeDefTaxon.scientificName)',
      synonym: 'Ижил нэр / Латин',
      extraPropsNotDefined: 'Энэ таксономын нэмэлт шинж чанарууд тодорхойлогдоогүй',
      importMissingPublishedTaxa:
        '{{count}} нийтлэгдсэн таксон импортлосон файлд олдоогүй тул өөрчлөгдөлгүй үлдлээ. Кодууд: {{codes}}',
      importMissingPublishedTaxaTruncated: '$t(taxonomy.edit.importMissingPublishedTaxa) (+{{extra}} дахин)',
    },
    taxaCount: 'Таксоны тоо',
    vernacularNameLabel: 'Нутгийн нэрийн шошго',
  },

  categoryList: {
    batchImport: 'Ангилалуудыг багцаар импортлох (ZIP-ээс)',
    batchImportCompleteSuccessfully: `{{importedCategories}} ангилал амжилттай импортлогдлоо!
{{insertedCategories}} шинэ
{{updatedCategories}} шинэчлэгдсэн`,
    cloneFromAnotherSurvey: {
      title: 'Өөр судалгаанаас ангилал хуулах',
      sourceSurvey: 'Эх сурвалж судалгаа',
      sourceCategory: 'Эх сурвалж ангилал',
      loadingSurveys: 'Судалгаанууд ачаалж байна...',
      noSurveysAvailable: 'Судалгаа алга байна',
      selectSurveyFirst: 'Эхлээд судалгаа сонгоно уу',
      loadingCategories: 'Ангилал ачаалж байна...',
      noCategoriesAvailable: 'Сонгосон судалгаанд ангилал алга байна',
    },
    itemsCount: 'Элементүүдийн тоо',
    types: {
      flat: 'Хавтгай',
      hierarchical: 'Иерархи',
      reportingData: 'Тайлагнах өгөгдөл',
    },
  },

  categoryEdit: {
    header: 'Ангилал',
    addLevel: 'Түвшин нэмэх',
    categoryName: 'Ангиллын нэр',
    cantBeDeleted: `$t(common.cantBeDeletedUsedItem, {'item': 'category'})`,
    cantBeDeletedLevel: `$t(common.cantBeDeletedUsedItem, {'item': 'category level'})`,
    confirmDelete: 'Ангилал {{categoryName}}-г устгах уу?\n$t(common.cantUndoWarning)',
    confirmDeleteEmptyCategory: 'Ангилал **хоосон** тул устгагдах болно. Үргэлжлүүлэх үү?',
    confirmDeleteLevel: `Түвшин '{{levelName}}'-г бүх элементүүдтэй хамт устгах уу?\n$t(common.cantUndoWarning)`,
    confirmDeleteItem: `Элементийг устгах уу?

$t(common.cantUndoWarning)`,
    confirmDeleteItemWithChildren: `Элементийг бүх хүүхдүүдтэй нь хамт устгах уу?

$t(common.cantUndoWarning)`,
    convertToReportingDataCategory: {
      buttonLabel: 'Тайлагнах өгөгдөл болгох',
      confirmMessage: `Энэ ангиллыг Тайлагнах өгөгдлийн ангилал болгон хөрвүүлэх үү?

Түвшингүүдийг level_1, level_2... level_N болгон нэрлэх бөгөөд элементүүдэд нэмэлт 'area' шинж чанар нэмэгдэнэ.`,
    },
    convertToSimpleCategory: {
      confirmMessage: `Энэ Тайлагнах өгөгдлийн ангиллыг энгийн ангилал болгон хөрвүүлэх үү?`,
    },
    deleteItem: 'Элемент устгах',
    level: {
      title: 'Түвшин {{levelPosition}}',
      noItemsDefined: 'Элемент тодорхойлогдоогүй',
      selectItemFromPreviousLevel: 'Өмнөх түвшнээс элемент сонгох',
    },

    importSummary: {
      columns: 'Багана',
      columnTypeSummary: 'Түвшин {{level}} $t(categoryEdit.importSummary.columnType.{{type}})',
      columnTypeExtra: '$t(extraProp.label)',
      columnTypeDescription: 'Тайлбар ({{language}})',
      columnTypeLabel: 'Шошго ({{language}})',
      columnType: {
        code: 'код',
        description: 'тайлбар',
        label: 'шошго',
        extra: '$t(extraProp.label)',
      },
      dataType: 'Өгөгдлийн төрөл',
      title: 'Ангиллын импортын хураангуй',
    },
    reportingData: 'Тайлагнах өгөгдөл',
    templateFor_samplingPointDataImport_csv: 'Түүвэрлэлтийн цэгийн загвар (CSV)',
    templateFor_samplingPointDataImport_xlsx: 'Түүвэрлэлтийн цэгийн загвар (Excel)',
  },

  extraProp: {
    label: 'Нэмэлт талбар',
    label_plural: 'Нэмэлт',
    addExtraProp: 'Талбар нэмэх',
    dataTypes: {
      geometryPoint: 'Геометрийн цэг',
      number: 'Тоо',
      text: 'Текст',
    },
    editor: {
      title: '$t(extraProp.label_plural)-г засах',
      confirmDelete: 'Нэмэлт шинж чанар "{{name}}"-г устгах уу?',
      confirmSave: `Нэмэлт шинж чанарын тодорхойлолтуудад өөрчлөлт хадгалах уу?

  **Анхааруулгууд**:

  {{warnings}}`,
      warnings: {
        nameChanged: 'Нэр {{nameOld}}-ээс {{nameNew}} болж өөрчлөгдсөн',
        dataTypeChanged: 'Өгөгдлийн төрөл {{dataTypeOld}}-ээс {{dataTypeNew}} болж өөрчлөгдсөн',
      },
    },
    name: 'Шинж чанар {{position}} нэр',
    value: 'Утга',
  },

  record: {
    ancestorNotFound: 'Бичлэгт дээд зангилаа олдсонгүй',
    keyDuplicate: 'Бичлэгийн түлхүүр давхцсан',
    oneOrMoreInvalidValues: 'Нэг буюу хэд хэдэн утга хүчингүй байна',
    uniqueAttributeDuplicate: 'Давхцсан утга',

    attribute: {
      customValidation: 'Хүчингүй утга',
      uniqueDuplicate: 'Давхцсан утга',
      valueInvalid: 'Хүчингүй утга',
      valueRequired: 'Шаардлагатай утга',
    },
    entity: {
      keyDuplicate: 'Объектын түлхүүр давхцсан',
    },
    nodes: {
      count: {
        invalid: '{{nodeDefName}} зангилаа нь яг {{count}} байх ёстой',
        maxExceeded: '{{nodeDefName}} зангилаа нь {{maxCount}}-ээс бага эсвэл тэнцүү байх ёстой',
        minNotReached: '{{nodeDefName}} зангилаа нь {{minCount}}-ээс их эсвэл тэнцүү байх ёстой',
      },
    },
  },

  // ====== Common components

  expressionEditor: {
    and: 'БА',
    or: 'ЭСВЭЛ',
    group: 'Бүлэг ()',
    var: 'Хувьсагч',
    const: 'Тогтмол утга',
    call: 'Функц',
    operator: 'Оператор',

    geoCoordinateAtDistanceEditor: {
      coordinateAttributeOrigin: 'Эх координатын шинж чанар',
      distanceAttribute: 'Зайны шинж чанар',
      bearingAttribute: 'Азимутын шинж чанар',
    },

    coordinateAttributeWithPosition: 'Координат шинж чанар {{position}}',

    dateTimeDiffEditor: {
      firstDateAttribute: 'Эхний огнооны шинж чанар',
      firstTimeAttribute: 'Эхний цагийн шинж чанар',
      secondDateAttribute: 'Хоёр дахь огнооны шинж чанар',
      secondTimeAttribute: 'Хоёр дахь цагийн шинж чанар',
    },
    error: {
      selectOneVariable: 'Нэг хувьсагч сонгоно уу',
    },

    header: {
      editingExpressionForNodeDefinition: '"{{nodeDef}}"-ийн {{qualifier}} илэрхийллийг засах',
      editingFunctionForNodeDefinition: '"{{nodeDef}}"-ийн "{{functionName}}" функцийг засах',
    },

    qualifier: {
      'default-values': 'үндсэн утга',
      'default-values-apply-if': 'үндсэн утга хэрэглэх бол',
      'editable-if': 'хэрэв засварлах боломжтой бол',
      'max-count': 'хамгийн их тоо',
      'min-count': 'хамгийн бага тоо',
      'relevant-if': 'хэрэв хамааралтай бол',
      validations: 'баталгаажуулалтын дүрэм',
      'validations-apply-if': 'баталгаажуулалтын дүрэм хэрэглэх бол',
      'visible-if': 'хэрэв харагдах бол',
    },

    selectAFunction: 'Функц сонгох',

    valueType: {
      constant: 'Тогтмол',
      expression: 'Илэрхийлэл',
    },
  },
}
